import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import 'moment/locale/es-mx'
import SearchView from './views/SearchView/SearchView'
import Login from './views/Login/Login'
import Results from './views/Results/Results'
import Details from './views/Details/Details'
import Ticket from './views/Ticket/Ticket'
import Header from './components/Layout/Header'
import AuthRoute from './security/AuthRoute'
import GenerateTicket from './views/GenerateTicket/GenerateTicket'
import StorePurchase from './views/StorePurchase/StorePurchase'
import ChooseProducts from './views/ChooseProducts/ChooseProducts'
import ClientTicket from './views/ClientTicket/ClientTicket'
import ShowTicket from './views/ShowTicket/ShowTicket'
import OnlinePurchase from './views/OnlinePurchase/OnlinePurchase'

const App = () => {
  return (
    <Router>
      <Grid container>
        <Switch>
          <Route path="/" exact component={Login} />
          <Route path="/login" exact component={Login} />
          <Route path="/generar-ticket" exact component={GenerateTicket} />
          <Route path="/compra-tienda" exact component={StorePurchase} />
          <Route path="/compra-online" exact component={OnlinePurchase} />
          <Route path="/seleccionar-productos" exact component={ChooseProducts} />
          <Route path="/ticket-cliente" exact component={ClientTicket} />
          <Route path="/ticket" exact component={ShowTicket} />
          <>
            <Header />
            <AuthRoute path="/buscar" exact component={SearchView} />
            <AuthRoute path="/resultados" exact component={Results} />
            <AuthRoute path="/detalle" exact component={Details} />
            <AuthRoute path="/ticket-imprimir" exact component={Ticket} />
          </>
        </Switch>
      </Grid>
    </Router>
  )
}

export default App
